// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "raw": "c0000fe4",
    "hash": "c0000fe4",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "c0000fe4",
    "semverString": null,
    "version": "2.13.3"
};
/* tslint:enable */
